// HEZO wordmark — copied directly from hezo-ops/public/hezo-logo.svg so the
// Scan-App looks tonally consistent with the rest of the HEZO surface.
//
// The SVG is inlined so the bundle has no external image dependency; tweaks
// to the master logo would need a manual copy back-and-forth. That's
// acceptable here.

export function HezoLogo({ className = "" }: { className?: string }): React.ReactElement {
  return (
    <svg
      viewBox="0 0 775.33 280"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="HEZO"
      className={className}
    >
      <path
        fill="currentColor"
        d="M77.18,115.45l36.18,36.18c3.52,3.35,7.2,3.35,10.72,0l30.82-30.82c3.35-3.52,3.35-7.2,0-10.72l-36.18-36.18,11.89-11.72,94.63,94.63-11.72,11.89-36.18-36.18c-3.52-3.35-7.2-3.35-10.72,0l-30.82,30.82c-3.35,3.52-3.35,7.2,0,10.72l36.18,36.18-11.89,11.72-94.63-94.63,11.72-11.89ZM296.1,62.19l11.72,11.72-47.9,48.07c-3.52,3.35-3.52,7.2,0,10.55l18.93,19.09c3.52,3.35,7.2,3.35,10.72,0l37.18-37.35,11.89,11.89-37.35,37.18c-3.35,3.52-3.35,7.2,0,10.72l19.09,18.93c3.35,3.52,7.2,3.52,10.55,0l48.07-47.9,11.72,11.72-65.16,65.16-94.64-94.63,65.16-65.16ZM502.29,187.64l42.54-42.54,11.73,11.72-65.16,65.16-11.72-11.72-18.59-110.55c-1.17-6.03-5.86-7.37-10.05-3.18l-38.86,39.03-11.89-11.89,61.64-61.47,11.72,11.72,18.59,110.55c1.17,6.03,6.03,7.2,10.05,3.18ZM691.39,190.82l-.17.17c-20.77,20.77-44.22,20.77-64.99,0l-33.33-33.33c-20.77-20.77-20.94-44.05,0-64.99l.17-.17c20.94-20.94,44.05-20.94,64.99,0l33.33,33.33c20.77,20.77,20.77,44.22,0,64.99ZM679.33,179.1l.17-.17c13.4-13.23,12.9-28.47-.84-42.21l-31.49-31.49c-13.9-13.9-28.98-14.24-42.21-.84l-.17.17c-13.4,13.23-12.9,28.47.84,42.21l31.49,31.49c13.57,13.57,28.98,14.24,42.21.84Z"
      />
    </svg>
  );
}
